<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'FIXED_TEMPLATES' }
  ]"
></breadcrumbs>

<page-header title="FIXED_TEMPLATES"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div
      class="field is-narrow"
      *ngFor="let fixedTemplate of fixedTemplates; let index = index"
    >
      <label
        class="label"
        [translationEditableDirective]="fixedTemplate.id.name"
        >{{ fixedTemplate.id.title }}</label
      >
      <div class="control">
        <ng-select
          class="is-small"
          [items]="templates"
          [multiple]="false"
          [closeOnSelect]="true"
          (change)="handleFieldChange($event?.id, 'templateId', index)"
          [ngClass]="{
            'is-danger': hasError('fixedTemplates.' + index + '.templateId')
          }"
          bindLabel="name"
          bindValue="id"
          [ngModelOptions]="{ standalone: true }"
          [ngModel]="getField([index, 'templateId'])"
          [typeahead]="onTemplatesAutocomplete$"
        >
        </ng-select>
      </div>
      <p
        class="help is-danger"
        *ngIf="hasError('fixedTemplates.' + index + '.templateId')"
      >
        {{ getError('fixedTemplates.' + index + '.templateId') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      (click)="onSubmit($event)"
      translationEditableDirective="SAVE"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
</div>
